import Profile from '../../pages/user/Profile';
import ShowProfile from '../../pages/user/ShowProfile';
import ChangePassword from '../../pages/user/ChangePassword';
import EditProfile from '../../pages/user/EditProfile';
import SetupTfa from '../../pages/user/SetupTfa';
import UserContacts from '../../pages/user-contacts/UserContacts';
import UploadUserContacts from "../../pages/user-contacts/UploadUserContacts"; // MLD-2867
import ShowUserContact from '../../pages/user-contacts/ShowUserContact';
import AppCompose from '../../pages/emails/AppCompose';
import AppContentLibrary from '../../pages/content/AppContentLibrary';
import OpenPresentation from '../../pages/content/OpenPresentation.vue';
import AppPresentPresentation from '../../pages/content/AppPresentPresentation';
import UserDashboard from '../../pages/dashboards/UserDashboard';
import PresentationActivity from '../../pages/insights/PresentationActivity';
import PresentationRoute from '../../pages/presentations/PresentationRoute';
import Search from "../../pages/search/Search"; // MLD-2483
import ShowSession from '../../pages/insights/ShowSession';
import EditPresentationNotePopupForm from '../../pages/presentation_notes/EditPresentationNotePopupForm.vue';
import PresentationNotes from '../../pages/presentation_notes/PresentationNotes.vue';
import UserSharedLinks from '../../pages/shared_links/UserSharedLinks.vue';

import {authGuard} from '../guards';

function getRoutes(routePrefix, layout) {

  const basePath = routePrefix === 'library'
    ? '/v2/app/content'
    : '/v2/mobile';

  return [
    {
      path: basePath,
      name: `${routePrefix}.home`,
      component: AppContentLibrary,
      meta: {
        layout: layout,
        title: `Content Library`,
        allow_restricted_user: true, // MLD-2750
      },
    },
    { // MLD-5740
      path: `${basePath}/:presentationID(\\d+)/open`,
      name: `${routePrefix}.open`,
      component: OpenPresentation,
      meta: {
        layout: layout,
        allow_restricted_user: true,
      },
    },
    { // MLD-2359
      path: `${basePath}/:presentationID(\\d+)/present`,
      name: `${routePrefix}.present`,
      component: AppPresentPresentation,
      meta: {
        layout: layout,
        allow_restricted_user: true, // MLD-2750
      },
    },
    { // MLD-2359
      path: `${basePath}/presentations/:presentationID(\\d+)/notes`,
      name: `${routePrefix}.presentation.notes`,
      component: PresentationNotes,
      meta: {
        layout: layout,
        allow_restricted_user: true, // MLD-2750
      },
    },
    { // MLD-6435
      path: `${basePath}/popup/presentations/:presentationID(\\d+)/edit-note`,
      name: `${routePrefix}.popup.presentation_note.edit`,
      component: EditPresentationNotePopupForm,
      meta: {
        layout: 'popup',
      },
    },
    {  // MLD-2679
      path: `${basePath}/presentations/:presentationID(\\d+)`,
      component: PresentationRoute,
      children: [
        {
          path: `activity`,
          name: `${routePrefix}.presentation.activity`,
          component: PresentationActivity,
          meta: {
            layout: layout,
            title: `Engagement & Insights`,
            allow_restricted_user: false, // MLD-2750
          },
        },
      ],
    },
    { // MLD-2483
      path: `${basePath}/search`,
      name: `${routePrefix}.search`,
      component: Search,
      meta: {
        layout: layout,
        title: `Search Results`,
        allow_restricted_user: false,
      }
    },
    { // MLD-2679
      path: `${basePath}/sessions/:sessionID(\\d+)`,
      name: `${routePrefix}.session.show`,
      component: ShowSession,
      meta: {
        layout: layout,
        title: `Session`,
        allow_restricted_user: false, // MLD-2750
      }
    },
    {
      path: `${basePath}/user/dashboard`,
      name: `${routePrefix}.user.dashboard`,
      component: UserDashboard,
      meta: {
        layout: layout,
        title: `My Dashboard`,
        allow_restricted_user: false, // MLD-2750
      }
    },
    // UserContacts
    { // MLD-2503
      path: `${basePath}/contacts`,
      component: UserContacts,
      name: `${routePrefix}.user_contacts.index`,
      meta: {
        layout: layout,
        title: `My Contacts`,
        allow_restricted_user: false, // MLD-2750
      },
    },
    { // MLD-2524
      path: `${basePath}/contacts/:contactID(\\d+)`,
      component: ShowUserContact,
      name: `${routePrefix}.user_contact.show`,
      meta: {
        layout: layout,
        title: `View Contact`,
        allow_restricted_user: false, // MLD-2750
      },
    },
    { // MLD-2867
      path: `${basePath}/contacts/upload`,
      component: UploadUserContacts,
      name: `${routePrefix}.user_contacts.upload`,
      meta: {
        layout: layout,
        title: `Upload Contacts`,
        allow_restricted_user: false,
      },
    },
    // Sending Emails
    {
      path: `${basePath}/compose`,
      name: `${routePrefix}.compose`,
      component: AppCompose,
      meta: {
        layout: layout,
        title: `Compose Email`,
        allow_restricted_user: true, // MLD-2750
      },
    },
    { // MLD-7625
      path: `${basePath}/shared-links`,
      name: `${routePrefix}.shared_links.index`,
      component: UserSharedLinks,
      meta: {
        layout: layout,
        title: 'My Shared Links',
      },
    },
    // MLD-2635 - Manage My Account
    {
      path: `${basePath}/account`,
      component: Profile,
      children: [
        {
          path: ``,
          name: `${routePrefix}.show_profile`,
          component: ShowProfile,
          meta: {
            layout: layout,
            title: `My Profile`,
            allow_restricted_user: true, // MLD-2750
          },
        },
        {
          path: `change-password`,
          name: `${routePrefix}.change_password`,
          component: ChangePassword,
          meta: {
            layout: layout,
            title: `Change My Password`,
            allow_restricted_user: true, // MLD-2750
          },
        },
        {
          path: `edit`,
          name: `${routePrefix}.edit_profile`,
          component: EditProfile,
          meta: {
            layout: layout,
            title: `Edit My Profile`,
            allow_restricted_user: true, // MLD-2750
          },
        },
        {
          path: `setup-tfa`,
          name: `${routePrefix}.setup_tfa`,
          component: SetupTfa,
          meta: {
            layout: layout,
            title: `Setup Two-Factor Authentication`,
            allow_restricted_user: true, // MLD-2750
          },
        },
      ]
    },
  ];
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]
